import { render, staticRenderFns } from "./edit_record.vue?vue&type=template&id=12392079&scoped=true&"
import script from "./edit_record.vue?vue&type=script&lang=js&"
export * from "./edit_record.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12392079",
  null
  
)

export default component.exports